<template>
  <div :class="['kyra-color-picker', {inline}]">
    <v-btn
        @click="show = true"
        :width="btnWidth"
        height="30"
        :style="{color: textColor}"
        small
        :color="selectedColor">
      {{label}}
      <v-icon @click.stop.prevent="$emit('click:clear')" size="20" class="ml-2" v-if="clearBtn">highlight_off</v-icon>
    </v-btn>
    <v-dialog v-model="show" max-width="400px" persistent>
      <v-card>
        <v-card-title>
          <div class="title">Selecciona un color</div>
        </v-card-title>
        <v-card-text>
          <v-color-picker
              class="mx-auto"
              hide-mode-switch
              hide-inputs
              v-model="color"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed small @click="cancel">Cancelar</v-btn>
          <v-btn color="primary" small @click="pickColor">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const tinycolor = require('tinycolor2')

export default {
  name: "KyraColorPicker",
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    clearBtn: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'color'
    },
    value:{
      type: String,
      default: '#ffffff'
    },
    btnWidth: {
      type: String,
      default: '100px'
    }
  },
  data(){
    return {
      show: false,
      color: '#ffffff',
      selectedColor: '#ffffff',
    }
  },
  created(){
    const vm = this
    vm.color = vm.value
    vm.selectedColor = vm.value
  },
  methods:{
    cancel(){
      const vm = this
      vm.color = vm.selectedColor
      vm.show = false
    },
    pickColor(){
      const vm = this
      vm.selectedColor = vm.color
      vm.$nextTick(() => {
        vm.$emit('change', vm.selectedColor)
        vm.show = false
      })
    }
  },
  computed:{
    textColor(){
      const vm = this
      return tinycolor(vm.selectedColor).isLight() ? '#000000' : '#ffffff'
    }
  },
  watch:{
    value(val){
      const vm = this
      vm.color = val
      vm.selectedColor = val
    }
  }
}
</script>

<style scoped>

  .kyra-color-picker{
   margin: 4px;
  }

  .kyra-color-picker.inline{
    display: inline-block;
  }

</style>
